<template>
  <div v-lazy-load="shouldUseLazyLoad" class="fashion-brand-container">
    <FashionHeader
      :id="`${categoryKey}-${brandData.id}`"
      class="fashion-header"
      :header-background-url="brandData.header_background"
      :header-logo-url="brandData.logo"
      :brand-id="brandData.id"
      :outfit-type="OutfitTypeEnum.ORIGINAL"
    />
    <NewArrivalBadge :brand-data="brandData" :categoryKey="categoryKey"></NewArrivalBadge>
    <div class="brand-outfits-container" v-if="visible">
      <FashionOutfitPreview
        class="brand-outfit"
        v-for="outfit in brandData.outfits"
        :key="outfit.id"
        :outfit-type="outfit.outfit_type"
        :outfit-id="outfit.id"
        :outfit-image-url="outfit.image"
        :detailed-outfit-options="outfit.detailed_options"
        :brand-id="brandData.id"
        :brand-background="brandData.store_background"
        :tab-navigation-enabled="tabNavigationEnabled"
      />
    </div>
  </div>
</template>

<script>
import FashionHeader from '@/components/AvatarBuilderUI/Fashion/FashionHeader';
import FashionOutfitPreview from '@/components/AvatarBuilderUI/Fashion/FashionOutfitPreview';
import { OutfitTypeEnum } from '@/enum/outfit_type';
import NewArrivalBadge from '@/components/AvatarBuilderUI/NewArrivalBadge';

export default {
  name: 'AvatarBuilderFashionCategory',
  props: [
    'brandData', //: Object
    'categoryKey', //: String
    'brandIndex', //:Number
    'shouldForceLoadBrand', //:Boolean
    'tabNavigationEnabled', //:Boolean
  ],
  components: {
    FashionHeader,
    FashionOutfitPreview,
    NewArrivalBadge,
  },
  created: function() {
    this.OutfitTypeEnum = OutfitTypeEnum;
  },
  computed: {
    shouldUseLazyLoad: function() {
      return !this.shouldForceLoadBrand && this.brandIndex >= 1;
    },
  },
  data: function() {
    return {
      visible: false, // Managed by LazyLoad
      observer: null, // Managed by LazyLoad
    };
  },
};
</script>

<style scoped>
.fashion-brand-container {
  display: flex;
  flex-direction: column;
}

.fashion-header {
  flex-basis: 60px;
  width: 100%;
}

.brand-outfits-container {
  flex-basis: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.brand-outfit {
  cursor: pointer;
  margin: 0 0 2% 2%;
  width: 30.66666666666%;
  padding: 10px 0;
  background-color: #fcfcfc;
  border-radius: 10px;
}

.brand-outfit.selected {
  background-color: #e6f6ff;
  box-shadow: inset 0 0 0 2px #0baaff, inset 0 0 0 4px #ffffff;
  -webkit-box-shadow: inset 0 0 0 2px #0baaff, inset 0 0 0 4px #ffffff;
}

@media (hover: hover) {
  .brand-outfit:hover {
    box-shadow: inset 0 0 0 2px rgba(217, 217, 217, 0.17);
  }
}

@media (prefers-color-scheme: dark) {
  .brand-outfit {
    background-color: #1e1e1e;
  }

  .brand-outfit.selected {
    background-color: #1f1f1f;
    box-shadow: inset 0 0 0 2px #0a92ff, inset 0 0 0 4px #121212;
    -webkit-box-shadow: inset 0 0 0 2px #0a92ff, inset 0 0 0 4px #121212;
  }
}
</style>
